import * as React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import {BodyText} from './text.js'
import Icon from './icon-inline-page.js'
import Link from './link.js'
import Image from './background-image.js'

const SearchCard = ({
  page
}) => {
  const title = page.title
  const type = page.type.name
  const to = page.path
  const props = {to}

  return ( 
    <Container {...props}>
      <Icon/>
      <Title>{title}</Title>
      <Type> / {type}</Type> 
    </Container>
  )
}

const Container = styled(Link)`
  display: flex;
  align-items: center;
  padding: .5em;
  margin-bottom: .5em;

  &:hover {
    background: rgba(0,0,0,.1);
  }
`

const Cover = styled.article`
  width: 10rem;
  height:10rem;
`

const Title = styled(BodyText)`
  font-size: ${theme.font.size.p2};
  font-family: ${theme.font.family.bold};
  margin-left: .5em;
  flex-shrink: 0;
`

const Type = styled(BodyText)`
  font-size: ${theme.font.size.p2};
  margin-left: .5em;
  opacity: .5;
  flex-shrink: 0;
`

export default SearchCard